import { DrugPageTranslations } from "./types";

export const deTranslations: DrugPageTranslations = {
    title: "Medikamente",
    updateAllergies: "Informationen zu Allergien aktualisieren",
    doPatientHasAllergies: "Bestehen irgendwelche Allergien?",
    yes: "Ja",
    no: "Nein",
    addAllergy: "Allergien hinzufügen (durch Komma getrennt)",
    submitAllergies: "Speichern",
    drugType: "Medikamententyp",
    selectOrType: "Auswählen oder eingeben",
    prescribe: "Verabreichen",
    time: "Zeit",
    drugName: "Wirkstoff",
    route: "Applikationsweg",
    dose: "Dosis",
    prescribedDrugs: "Verschriebene Medikamente",
};
